import { AsyncPipe } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { AuthService } from "@core/auth.service";
import { IonicModule, ModalController, NavParams } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { InProgressAnimationComponent } from "../../../components/in-progress-animation/in-progress-animation.component";
import { excelLabelForIndex } from "../../syndicate/utils/excel-line-keys.util";
import { CheckWinningsRepositoryService } from "../check-winnings-repository.service";

@Component({
  selector: "app-checked-tickets",
  templateUrl: "./checked-tickets.component.html",
  styleUrls: ["./checked-tickets.component.scss"],
  standalone: true,
  imports: [
    IonicModule,
    InProgressAnimationComponent,
    AsyncPipe,
    TranslatePipe,
  ],
})
export class CheckedTicketsComponent implements OnInit {
  showSlides: boolean;
  ticketSlider = {
    initialSlide: 0,
    slidesPerView: 1.08,
  };
  repeatSlides = [1, 2];
  playersCount = 46;
  winningCombination = [14, 14, 14, 14, 14, 14, 14];
  winningAmount = "69M";

  getTicketDetails$ = this.checkWinningService.getPrizeBreakdownTickets(
    this.navParams?.data.claimEventId,
    this.navParams?.data.dateClicked
  );

  ionViewWillEnter() {
    /* To overcome ionic slider unwanted sliding behaviour when
         component loaded with slider as modal */
    this.showSlides = true;
  }
  userId: string;

  constructor(
    private modelctrl: ModalController,
    private navParams: NavParams,
    private checkWinningService: CheckWinningsRepositoryService,
    private analytics: AngularFireAnalytics,
    public translate: TranslateService,
    private authService: AuthService
  ) {
    this.authService?.selectedlanguage$?.subscribe((l) => {
      if (l) {
        translate.use(l ? l : "en");
      }
    }, err => { return (err) });
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("CheckedTicketsComponent")
      ?.then((uid) => {
        this.userId = uid;
        this.analytics.logEvent("prize_breakdown_tickets_screen", {
          userId: this.userId,
        });
      })
      .catch((error) => {
        return error;
      });

  }

  alphabeticOrder(val) {
    return excelLabelForIndex(val);
  }

  goBack() {
    this.modelctrl.dismiss().catch((err) => { return err });
  }
}
